import { camelCase, mapKeys } from 'lodash';

export const transformKeysToCamelcase = snakeCaseKeysObject => {
  if (!snakeCaseKeysObject) return {};

  return mapKeys(snakeCaseKeysObject, (_, key) => camelCase(key.toLowerCase()));
};
